export const lightWarningColors = {
    // TEXT
    warningText: 'var(--theme-ui-colors-squash)',
    // BACKGROUND
    warningBg: 'var(--theme-ui-colors-coconut)',
    warningBgMedium: 'var(--theme-ui-colors-banana)',
    // BORDER
    warningBorder: 'var(--theme-ui-colors-orange)',
    warningBorderActive: 'var(--theme-ui-colors-squash)',
    // ICON
    warningIcon: 'var(--theme-ui-colors-orange)',
    warningIconActive: 'var(--theme-ui-colors-squash)',
};
export const darkWarningColors = {
    // TEXT
    warningText: 'var(--theme-ui-colors-squash)',
    // BACKGROUND
    warningBg: 'var(--theme-ui-colors-coconut)',
    warningBgMedium: 'var(--theme-ui-colors-banana)',
    // BORDER
    warningBorder: 'var(--theme-ui-colors-orange)',
    warningBorderActive: 'var(--theme-ui-colors-squash)',
    // ICON
    warningIcon: 'var(--theme-ui-colors-orange)',
    warningIconActive: 'var(--theme-ui-colors-squash)',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2FybmluZ0NvbG9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9zZW1hbnRpY0NvbG9ycy93YXJuaW5nQ29sb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHO0lBQ2hDLE9BQU87SUFDUCxXQUFXLEVBQUUsK0JBQStCO0lBRTVDLGFBQWE7SUFDYixTQUFTLEVBQUUsZ0NBQWdDO0lBQzNDLGVBQWUsRUFBRSwrQkFBK0I7SUFFaEQsU0FBUztJQUNULGFBQWEsRUFBRSwrQkFBK0I7SUFDOUMsbUJBQW1CLEVBQUUsK0JBQStCO0lBRXBELE9BQU87SUFDUCxXQUFXLEVBQUUsK0JBQStCO0lBQzVDLGlCQUFpQixFQUFFLCtCQUErQjtDQUNuRCxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQThCO0lBQzFELE9BQU87SUFDUCxXQUFXLEVBQUUsK0JBQStCO0lBRTVDLGFBQWE7SUFDYixTQUFTLEVBQUUsZ0NBQWdDO0lBQzNDLGVBQWUsRUFBRSwrQkFBK0I7SUFFaEQsU0FBUztJQUNULGFBQWEsRUFBRSwrQkFBK0I7SUFDOUMsbUJBQW1CLEVBQUUsK0JBQStCO0lBRXBELE9BQU87SUFDUCxXQUFXLEVBQUUsK0JBQStCO0lBQzVDLGlCQUFpQixFQUFFLCtCQUErQjtDQUNuRCxDQUFDIn0=